import styled from "styled-components"
import { log } from "three"
import { Colors, Sizes, FontBold, Breakpoints } from "./../../utils/variables"

export const Item = styled.li`
  padding: 30px;

  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  &:last-of-type {
    border-bottom: 0;

    padding-bottom: 0;
  }

  @media screen and (min-width: ${Breakpoints.wide}) {
    padding: 70px 0;

    &:last-of-type {
      padding-bottom: 20px;
    }
  }
`

export const Container = styled.div`
  width: 100%;
  max-width: ${Sizes.maxContentWidth};

  margin: 0 auto;
`

export const Header = styled.header`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  position: relative;
`

export const Line = styled.span`
  display: inline-block;
  vertical-align: middle;

  width: 30px;
  height: 1px;

  margin: 0 15px;

  background-color: ${Colors.black};

  @media screen and (min-width: ${Breakpoints.wide}) {
    width: 70px;

    margin: 0 15px;
  }
`

export const Title = styled.h3`
  ${FontBold}
  font-size: 13px;
  line-height: 25px;

  @media screen and (min-width: ${Breakpoints.wide}) {
    font-size: 18px;
  }
`

export const Icon = styled.span`
  display: inline-block;
  vertical-align: middle;
`

export const Button = styled.button`
  border: none;
  outline: none;
  background-color: transparent;

  &:before {
    content: "";
    position: absolute;

    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    background-color: transparent;
  }

  img {
    transform: ${props => (props.active ? `rotate(180deg)` : `rotate(0)`)};
  }
`

export const Close = styled.img`
  display: block;

  width: 6px;
  height: 6px;

  transition: transform 0.15s ease-out;

  @media screen and (min-width: ${Breakpoints.wide}) {
    width: 13px;
    height: 13px;
  }
`

export const Content = styled.div`
  display: ${({ active }) => (active ? "blok" : "none")};
  padding-top: 30px;

  @media screen and (min-width: ${Breakpoints.wide}) {
    padding-top: 60px;
  }
`

export const Description = styled.p``
